import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { FotoKategorienService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [FotoKategorienService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class FotoKategorienServiceModule {}
